/**
 * `trainingAvailable` はサーバーの対応可否を示し、フィーチャーフラグは公開環境・組織を制御する。
 * 未デプロイ環境では trainingAvailable が undefined になり、スイッチを出さない。
 */
export function shouldShowTrainingMode({
  trainingAvailable,
  trainingFeatureEnabled
}: {
  trainingAvailable: boolean | undefined;
  trainingFeatureEnabled: boolean;
}) {
  return trainingAvailable === true && trainingFeatureEnabled;
}
function getEnableTrainingRequestValue(enabled: boolean | undefined): true | undefined {
  return enabled === true ? true : undefined;
}
export function toInstallFromSoftwareLibraryBody(params: {
  softwareLibraryId: string;
  enableTraining?: boolean;
}): {
  softwareLibraryId: string;
  enableTraining?: true;
} {
  const enableTraining = getEnableTrainingRequestValue(params.enableTraining);
  return {
    softwareLibraryId: params.softwareLibraryId,
    ...(enableTraining === true ? {
      enableTraining
    } : {})
  };
}

/**
 * トレーニングモード ON の Software はスクレイピングがアカウント取得の正。
 * CSV 取り込み導線（台帳追加直後・import-csv 画面）を出さない。
 */
export function isAccountCsvImportBlocked(trainingEnabled: boolean | undefined): boolean {
  return trainingEnabled === true;
}

/**
 * トレーニングモード ON かつレシピ未設定では、アカウント同期を起こさない。
 * スクレイピング step はレシピ無しだと no-op だが、押せる状態だと空同期に見える。
 */
export function isTrainingAccountSyncBlocked(params: {
  trainingEnabled: boolean | undefined;
  recipeConfigured: boolean | undefined;
}): boolean {
  return params.trainingEnabled === true && params.recipeConfigured !== true;
}